import { Helmet } from "react-helmet-async";

export default function SEOMeta(props) {
    return (
        <Helmet>
            <title>{props.title}</title>
            <meta name="description" content={props.description}></meta>
            <meta name="keywords" content="빌리언스, BILLIONS, 경남제약"></meta>

            <meta property="og:type" content="website"></meta>
            <meta property="og:title" content={props.title}></meta>
            <meta property="og:site_name" content="빌리언스"></meta>
            <meta property="og:description" content={props.description}></meta>
            <meta property="og:url" content={props.url}></meta>

            <link rel="canonical" href={props.url}></link>
        </Helmet>
    )
}